var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartGameLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141,
    height: 141,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1332-582H588V498h-1920z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".shp0{fill:none;stroke:#fff;stroke-width:4}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu - game not started",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval 3",
    className: "shp0",
    d: "M70.5 139C32.62 139 2 108.38 2 70.5 2 32.62 32.62 2 70.5 2 108.38 2 139 32.62 139 70.5c0 37.88-30.62 68.5-68.5 68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5",
    className: "shp0",
    d: "M55 52l35 22-35 22V52z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartGameLogo);
export default __webpack_public_path__ + "static/media/start_game_logo.9ff5a0bddd5da98af0348835d2eb0f24.svg";
export { ForwardRef as ReactComponent };